export default {
  loggedIn: {
    deposit: 'जमा करें',
    withdraw: 'निकासी',
    balance: 'कुल शेष',
    cash: 'नकद',
    bonus: 'बोनस',
    withdrawable: 'निकासी योग्य',
    transaction: 'लेन-देन',
    history: 'इतिहास',
    myBet: 'My Bet',
    rollover: 'रोलओवर',
    vault: 'तिजोरी',
    notification: 'सूचना',
    affiliate: 'सहयोगी - प्रति माह $5,000 कमाएं',
    affiliateTitle: 'सहयोगी',
    affiliateBadge: 'प्रति माह $5,000 कमाएं',
    settings: 'सेटिंग्स',
    currency: 'मुद्रा',
    language: 'भाषा',
    liveSupport: 'लाइव सहायता',
    signOut: 'साइन आउट'
  }
};
